import $ from 'cash-dom'
import { getCart, addItemsToCart } from '../resources/shopify-cart'
import { generateUID, getURLParam } from '../utilities/toolkit'
import { cart } from './cart'
import { setCollectionHandle } from '../pages/collection'
import { getNewPackingId } from '../utilities/cart-packing-id'
import { showToast } from './toast'
import { showSelectionPanel, hideSelectionPanel } from './BYS-selection-panel'
import { fetchProductData } from '../utilities/product'
import { elevarDataLayerViewEvent } from '../tracking/events/view-item'

class FreeFragrance {
  constructor() {
    const _ = this

    // selected product for free fragrance
    _.selectedProduct = null
    setCollectionHandle(Pura.collection.handle)

    // Check for pre-selected product from URL parameters
    const preSelected = getURLParam('selected') || false
    if (preSelected) _.updatePreSelected(preSelected)

    // Initialize UI bindings
    _.bindUI()
  }

  bindUI() {
    const _ = this

    // Listen for new products being loaded
    document.addEventListener('productsLoaded', (e) => {
      console.log('New products loaded:', e.detail)

      // Use the dedicated method to handle new products
      _.handleNewProducts()
    })

    // Open product modal when product is clicked
    document.addEventListener('click', async (e) => {
      const productCard = e.target.closest(
        '[data-action="show-BYS-selection-panel"], [data-action="show-free-fragrance-modal"]'
      )
      if (!productCard) return

      e.preventDefault()

      // Get product data
      const productId = productCard.getAttribute('data-product-id')
      const productHandle = productCard.getAttribute('data-product-handle')
      // First try to get product data from the page (like BYS does)
      let product = null
      const productDataScript = document.getElementById(
        `product-data-${productId}`
      )
      if (productDataScript) {
        try {
          product = JSON.parse(productDataScript.textContent)
        } catch (error) {
          console.error('Error parsing product data:', error)
        }
      }

      // If no product data in page, fetch it
      if (!product) {
        product = await fetchProductData(productHandle)
      }

      if (product) {
        // Track product view
        elevarDataLayerViewEvent(productHandle)

        // Store selected product
        _.selectedProduct = product

        // Force subscription only for free fragrances
        product.hasOTP = false
        product.hasSub = true

        // Show selection panel
        showSelectionPanel(product, 1).then(() => {
          // Update button text for free fragrance after panel is rendered
          $('#selection-form-button').text('Subscribe')
        })
      }
    })

    // Handle product selection from selection panel
    $(document).on(
      'click',
      '[data-action="add-selected-product-to-BYS"]',
      (e) => {
        e.preventDefault()

        // For free fragrance, we don't add to a set, we add directly to cart
        if (_.selectedProduct) {
          // Get purchase type from selection panel
          const purchaseType = $(
            '#product-selection-panel [name="purchase-type"]:checked'
          ).val()

          if (purchaseType != null) {
            _.selectedProduct.purchaseType = purchaseType

            if (purchaseType == 'SUB') {
              _.selectedProduct.subFrequency = $(
                '#product-selection-panel #sub-interval-frequency'
              ).val()
            }
          }

          _.addToCart()
          hideSelectionPanel()
        }
      }
    )

    // Handle direct subscribe button click (both subscribe-free-fragrance and select-fragrance)
    $(document).on(
      'click',
      '[data-action="subscribe-free-fragrance"], [data-action="select-fragrance"]',
      async (e) => {
        // Only handle select-fragrance on free fragrance pages
        const action = $(e.currentTarget).attr('data-action')
        if (
          action === 'select-fragrance' &&
          Pura.template?.suffix !== 'bys-free-fragrance'
        ) {
          return // Let other handlers deal with non-free-fragrance select buttons
        }

        e.preventDefault()

        const button = $(e.currentTarget)
        const productId = button.attr('data-product-id')
        const productHandle = button.attr('data-product-handle')

        // Disable button while processing
        button.prop('disabled', true).text('Adding...')

        // Get product data
        let product = null
        const productDataScript = document.getElementById(
          `product-data-${productId}`
        )

        if (productDataScript) {
          try {
            product = JSON.parse(productDataScript.textContent)
          } catch (error) {
            console.error('Error parsing product data:', error)
          }
        }

        // If no product data in page, fetch it
        if (!product) {
          product = await fetchProductData(productHandle)
        }

        if (product) {
          // Set product and force subscription
          _.selectedProduct = product
          _.selectedProduct.purchaseType = 'SUB'
          _.selectedProduct.subFrequency = '1' // Default to 4 weeks

          // Add to cart
          await _.addToCart()

          // Re-enable button
          button.prop('disabled', false).text('Subscribe')
        } else {
          // Re-enable button on error
          button.prop('disabled', false).text('Subscribe')
          showToast('Error loading product. Please try again.')
        }
      }
    )
  }

  async addToCart() {
    const _ = this

    if (!_.selectedProduct) {
      showToast('No product selected')
      return
    }

    // Get current cart for packing ID
    const cartData = await getCart()

    // Generate unique IDs
    const packingId = getNewPackingId(cartData)

    // Get product variant ID (use first variant if not specified)
    const variantId =
      _.selectedProduct.variant_id || _.selectedProduct.variants[0].id

    // Build cart request
    const request = {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: {
            _pura_UID: generateUID(),
            _pura_packing_id: packingId,
            _pura_line_discount: Pura.BYS.disKey,
            _pura_lock_duration: Pura.BYS.lock_duration,
            _pura_promo_id: Pura.BYS.bys_promo_id,
            _pura_group_role: 'parent',
            _pura_hide_quantity: true,
            _pura_full_price: (_.selectedProduct.price / 100).toFixed(2),
            _pura_full_price_currency: 'USD',
          },
        },
      ],
    }

    // Add subscription properties if this is a subscription product
    if (
      _.selectedProduct.selling_plans &&
      _.selectedProduct.selling_plans.length > 0
    ) {
      // Default to first selling plan (usually monthly)
      request.items[0].selling_plan = _.selectedProduct.selling_plans[0].id
    }

    // Add to cart
    try {
      await addItemsToCart(request)

      // Show success message
      showToast('Free fragrance added to cart!')

      // Update cart display
      cart.updateAndShow()

      // Reset selected product
      _.selectedProduct = null
    } catch (error) {
      console.error('Error adding free fragrance to cart:', error)
      showToast('Error adding product to cart. Please try again.')
    }
  }

  // Method to set collection handle for filtering
  setCollection(collectionHandle) {
    setCollectionHandle(collectionHandle)
  }

  // Method to update collection and reload products
  updateCollection(collectionHandle) {
    this.setCollection(collectionHandle)
    // Optionally trigger a collection reload or filter update
    // This would depend on how the collection filtering system works
  }

  // Method to handle pre-selected products from URL parameters
  updatePreSelected(preSelected) {
    const _ = this

    // For free fragrance, we typically only handle one product
    // Split by comma in case multiple are provided, but take the first
    const handle = preSelected.split(',')[0]

    if (handle) {
      // Fetch product data and set as selected
      fetchProductData(handle).then((product) => {
        if (product) {
          _.selectedProduct = product
          // Optionally trigger UI updates to show the pre-selected product
        }
      })
    }
  }

  // Method to check if user is eligible for free fragrance
  async checkEligibility() {
    const cartData = await getCart()

    // Check cart for subscription items
    const hasSubscription = cartData.items.some(
      (item) => item.selling_plan_allocation
    )

    // Check for minimum cart value or other eligibility criteria
    const meetsMinimumValue = cartData.total_price >= 5000 // $50 minimum

    return hasSubscription && meetsMinimumValue
  }

  // Method to handle newly loaded products
  handleNewProducts() {
    // Ensure subscribe buttons are visible and properly styled
    if (Pura.template && Pura.template.suffix === 'bys-free-fragrance') {
      // Show all subscribe buttons with proper styling
      $('[data-action="subscribe-free-fragrance"]').each((_, button) => {
        const $button = $(button)
        if (!$button.prop('disabled')) {
          $button
            .removeClass('hidden button button-sm')
            .addClass('button-outline')
            .text('Subscribe')
        }
      })

      // Also handle select-fragrance buttons on free fragrance pages
      $('[data-action="select-fragrance"]').each((_, button) => {
        const $button = $(button)
        if (!$button.prop('disabled')) {
          $button
            .removeClass('hidden button button-sm')
            .addClass('button-outline')
            .text('Subscribe')
        }
      })
    }
  }

  // Method to reinitialize after collection updates
  static reinitialize() {
    // Check if free fragrance instance exists
    if (window.Pura && window.Pura.freeFragrance) {
      // Handle new products
      window.Pura.freeFragrance.handleNewProducts()
      console.log('Free fragrance functionality reinitialized')
    }
  }
}

// Initialize on pages with free fragrance functionality
// Initialize if we have free fragrance elements on the page
const hasFreeFragranceElements = document.querySelector(
  '[data-action="show-free-fragrance-modal"], [data-action="subscribe-free-fragrance"]'
)

if (
  hasFreeFragranceElements ||
  (Pura.template && Pura.template.suffix === 'bys-free-fragrance')
) {
  const freeFragrance = new FreeFragrance()

  // Make instance available globally for debugging
  window.Pura = window.Pura || {}
  window.Pura.freeFragrance = freeFragrance
}

export default FreeFragrance
